import { Reducer } from 'react';
import { getType } from '@anm/helpers/saga/typesafe-actions';

import { HostedVideoActions } from '..';
import { saveVideoConfigsAsync } from '../actions';
import { getUpdatedConfigs, getUpdatedList } from '../helpers';

import { initialHostedVideoState } from './index';

const saveVideoConfigsReducer: Reducer<
  typeof initialHostedVideoState,
  HostedVideoActions
> = (state = initialHostedVideoState, action) => {
  switch (action.type) {
    case getType(saveVideoConfigsAsync.request): {
      return {
        ...state,
        saveVideoConfigs: {
          ...state.saveVideoConfigs,
          isPending: true,
          isError: false
        }
      };
    }
    case getType(saveVideoConfigsAsync.success): {
      const newConfigs = state.videoData?.configs;
      const playerColor = state.videoData?.customConfigs.playerColor;

      const { newConfigsWithColor, updatedPlayerConfigs } = getUpdatedConfigs({
        playerColor,
        configs: newConfigs!,
        sources: state.videoData?.sources
      });

      return {
        ...state,
        list: getUpdatedList(state.list, action.payload),
        saveVideoConfigs: {
          ...state.saveVideoConfigs,
          isPending: false,
          isError: false,
          error: null
        },
        videoData: {
          ...state.videoData!,
          configs: newConfigsWithColor,
          customConfigs: {
            ...state.videoData?.customConfigs,
            ...updatedPlayerConfigs
          },
          savedData: {
            ...state.videoData?.savedData!,
            configs: newConfigsWithColor
          }
        }
      };
    }
    case getType(saveVideoConfigsAsync.failure): {
      const error = action.payload;
      return {
        ...state,
        saveVideoConfigs: {
          ...state.saveVideoConfigs,
          error,
          isPending: false,
          isError: true
        }
      };
    }
    default:
      return state;
  }
};

export default saveVideoConfigsReducer;
